/* eslint-disable default-case */
import React, { useEffect, useMemo, useState } from "react";
import { Button, Flex, Text } from "@chakra-ui/react";
import Header from "components/header";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { CloseIcon } from "@chakra-ui/icons";

import ProfilingComplete from "../../assets/img/ProfilingComplete.webp";
import ProfilingStandard from "../../assets/img/ProfilingStandard.webp";
import ProfilingPilihanCareerTerbaik from "../../assets/img/ProfilingPilihanCareerTerbaik.webp";
import ProfilingSifatdanSikapDitempatKerja from "../../assets/img/ProfilingSifatdanSikapDitempatKerja.webp";
import ProfilingHubunganCintadanSosial from "../../assets/img/ProfilingHubunganCintadanSosial.webp";
import CoverProfilingComplete from "../../assets/img/CoverCompleteProfiling.png";
import CoverPotentialTalent from "../../assets/img/CoverPotentialTalent.png";
import CoverProfilingPilihanCareerTerbaik from "../../assets/img/CoverBestCareer.png";
import CoverProfilingSifatdanSikapDitempatKerja from "../../assets/img/CoverPersonalWorkstyle.png";
import CoverProfilingHubunganCintadanSosial from "../../assets/img/CoverRelationshipBehavior.png";
import useStyles from "./style";
import Footer from "components/footerUser";
import { Box } from "@chakra-ui/react";
import axios from "axios";
import PricingProfiling from "views/pricingProfiling";
import { CircularProgress, Snackbar, SnackbarContent } from "@mui/material";
import { formatPrice } from "utils/format";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const Profiling = (props) => {
  const styles = useStyles();
  const [activePage, setActivePage] = useState(0);
  const [service, setService] = useState();
  const [isShowPricing, setIsShowPricing] = useState(true);
  const [isShowModalPricing, setIsShowModalPricing] = useState(false);
  const [user, setUser] = useState();
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [loadingItems, setLoadingItems] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(`https://api.personatalenta.id/product/list`, {
        headers: {
          Authorization: `Bearer ${token ? token : ""}`,
          "Content-Type": "x-www-from-urlencode",
        },
      })
      .then((res) => {
        if (res.data && res.data.products) {
          setProducts(res.data.products);
        }
      })
      .catch((err) => {
        console.error("Error fetching products:", err);
      });
  }, []);

  useEffect(() => {
    if (props?.location?.hash?.split("#")[1]) {
      setActivePage(Number(props?.location?.hash?.split("#")[1]));
    }
  }, []);

  useEffect(() => {
    let localUser = localStorage.getItem("user");
    if (localUser) {
      setUser(JSON.parse(localUser));
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const baseUrl = "https://api.personatalenta.id/user/service/table-list";
      axios
        .get(baseUrl, {
          headers: {
            Authorization: `Bearer ${token ? token : ""}`,
            "Content-Type": "x-www-from-urlencode",
          },
        })
        .then((res) => {
          if (res?.data?.products) {
            setService(res.data.products.profiling);
          }
        })
        .catch((err) => {
          if (
            err.response.data.message === "Unauthorized" ||
            err.response.data === "Unauthorized"
          ) {
            // navigate('/');
          }
        });
    }
  }, []);

  useEffect(() => {
    if (service) {
      if (service.find((item) => item.code === code)?.isPurchase) {
        setIsShowPricing(false);
      } else {
        setIsShowPricing(true);
      }
    }
  }, [activePage, service]);

  const handleClosePricing = () => {
    setIsShowModalPricing(false);
  };

  const { title, color, img, url, cover, code, baseUrl } = useMemo(() => {
    switch (activePage) {
      case 0:
        return {
          code: "profiling_career",
          title: "PILIHAN KARIR TERBAIK",
          color: "#439450",
          img: ProfilingPilihanCareerTerbaik,
          url: "https://personatalenta.id/assets/pdf/ex-karir.pdf",
          baseUrl: "https://api.personatalenta.id/profiling/pdf/career",
          cover: CoverProfilingPilihanCareerTerbaik,
        };
      case 1:
        return {
          code: "profiling_workstyle",
          title: "PERSONAL WORKSTYLE",
          color: "#2F53F0",
          img: ProfilingSifatdanSikapDitempatKerja,
          url: "https://personatalenta.id/assets/pdf/ex-workstyle.pdf",
          baseUrl: "https://api.personatalenta.id/profiling/pdf/workstyle",
          cover: CoverProfilingSifatdanSikapDitempatKerja,
        };
      case 2:
        return {
          code: "profiling_relationship",
          title: "RELATIONSHIP BEHAVIOR",
          color: "#439450",
          img: ProfilingHubunganCintadanSosial,
          url: "https://personatalenta.id/assets/pdf/ex-relation.pdf",
          baseUrl: "https://api.personatalenta.id/profiling/pdf/relation",
          cover: CoverProfilingHubunganCintadanSosial,
        };
      case 3:
        return {
          code: "profiling_talent",
          title: "POTENTIAL TALENT",
          color: "#2F53F0",
          img: ProfilingStandard,
          url: "https://personatalenta.id/assets/pdf/ex-standard.pdf",
          baseUrl: "https://api.personatalenta.id/profiling/pdf/talent",
          cover: CoverPotentialTalent,
        };
      case 4:
        return {
          code: "profiling_complete",
          title: "COMPLETE PROFILING",
          color: "#439450",
          img: ProfilingComplete,
          url: "https://personatalenta.id/assets/pdf/ex-complete.pdf",
          baseUrl: "https://api.personatalenta.id/profiling/pdf/complete",
          cover: CoverProfilingComplete,
        };
    }
  });

  const handleBuy = () => {
    const selectedProduct = products.find((p) => p.code === code);
    if (!selectedProduct) return;

    if (user) {
      window.location.assign(
        `/dashboard/profile/${user.username}/checkout/${selectedProduct.id}`,
      );
    } else {
      window.location.assign("/login?service=matching");
    }
  };

  const downloadPdf = async (uri, name) => {
    console.log(uri);
    console.log(name);
    const response = await fetch(uri);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${name}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const onClickDownload = () => {
    setLoadingDownload(true);
    setErrorMessage("");
    const token = localStorage.getItem("token");
    axios
      .get(baseUrl, {
        headers: {
          Authorization: `Bearer ${token ? token : ""}`,
          "Content-Type": "x-www-from-urlencode",
        },
        responseType: "blob",
      })
      .then((res) => {
        setLoadingDownload(false);
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(res.data);
        a.download = `${title} ${user.name}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch((err) => {
        if (
          err.response?.data?.message === "Unauthorized" ||
          err.response?.data === "Unauthorized"
        ) {
          // navigate('/');
        }
        setLoadingDownload(false);
        setErrorMessage(err.message);
      })
      .finally(() => {
        setLoadingItems((prev) => ({ ...prev, [props.index]: false })); // Reset loading after completion
      });
  };

  const handleClose = () => {
    setLoadingDownload(false);
  };

  // Mobile Content Data Structure
  const mobileContentData = {
    0: {
      title: "Pilihan Karir Terbaik",
      customHeader: "Cara Mendapatkan Profiling Pilihan Karir Terbaik",
      desc: "",
      subDesc: "",
      isOrdered: true,
      points: [
        <span>
          Silakan untuk <b>Daftar/Login</b> terlebih dahulu.
        </span>,
        <span>
          Pastikan <b>data kelahiranmu</b> benar :{" "}
          <b>Tahun/Bulan/Hari/Jam, Jenis Kelamin</b>. Data ini mempengaruhi
          akurasi hasil profilingmu, untuk edit data bisa di cek di{" "}
          <b>
            <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                if (user && user !== "guess") {
                  window.location.assign("/dashboard/profile");
                } else {
                  localStorage.setItem("redirect_url", "/profiling");
                  window.location.assign("/login");
                }
              }}
            >
              Dashboard
            </span>{" "}
            → Edit Profile
          </b>
          .
        </span>,
        <span>
          Dilaman Profiling ini, klik <b>Beli Sekarang</b> muncul Draft Invoice
          → klik Lanjutkan pembayaran → muncul QRIS.
        </span>,
        <span>
          <b>Lakukan scan QRIS</b> untuk pembayaran dengan e-wallet atau mobile
          banking (Gopay, Link Aja, Dana, Shoopepay, Mobile Banking dll).
        </span>,
        <span>
          Setelah pembayaran berhasil, kamu akan diarahkan ke laman{" "}
          <b>
            <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                if (user && user !== "guess") {
                  window.location.assign("/dashboard/profile");
                } else {
                  localStorage.setItem("redirect_url", "/profiling");
                  window.location.assign("/login");
                }
              }}
            >
              Dashboard
            </span>{" "}
            → klik button Unduh
          </b>
          .
        </span>,
        <span>
          Tunggu, maks 1 menit (tergantung kecepatan jaringanmu) hasil
          Profilingmu akan terdownload di HP mu. Mudah bukan !
        </span>,
      ],
      briefDesc:
        "Profiling Pilihan Karir Terbaik ini dibuat khusus untuk kamu, berbeda satu orang dengan yang lainnya.\n\nTemukan pilihan karirmu!\nDi Profiling Pilihan Karir Terbaik ini, kamu bisa mengetahui karir yang paling cocok dengan karaktermu, hanya dalam hitungan menit.",
    },
    1: {
      title: "Gaya Kerja Personal",
      customHeader: "Cara Mendapatkan Profiling Personal Workstyle",
      desc: "",
      subDesc: "",
      isOrdered: true,
      points: [
        <span>
          Silakan untuk <b>Daftar/Login</b> terlebih dahulu.
        </span>,
        <span>
          Pastikan <b>data kelahiranmu</b> benar :{" "}
          <b>Tahun/Bulan/Hari/Jam, Jenis Kelamin</b>. Data ini mempengaruhi
          akurasi hasil profilingmu, untuk edit data bisa di cek di{" "}
          <b>
            <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                if (user && user !== "guess") {
                  window.location.assign("/dashboard/profile");
                } else {
                  localStorage.setItem("redirect_url", "/profiling");
                  window.location.assign("/login");
                }
              }}
            >
              Dashboard
            </span>{" "}
            → Edit Profile
          </b>
          .
        </span>,
        <span>
          Dilaman Profiling ini, klik <b>Beli Sekarang</b> muncul Draft Invoice
          → klik Lanjutkan pembayaran → muncul QRIS.
        </span>,
        <span>
          <b>Lakukan scan QRIS</b> untuk pembayaran dengan e-wallet atau mobile
          banking (Gopay, Link Aja, Dana, Shoopepay, Mobile Banking dll).
        </span>,
        <span>
          Setelah pembayaran berhasil, kamu akan diarahkan ke laman{" "}
          <b>
            <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                if (user && user !== "guess") {
                  window.location.assign("/dashboard/profile");
                } else {
                  localStorage.setItem("redirect_url", "/profiling");
                  window.location.assign("/login");
                }
              }}
            >
              Dashboard
            </span>{" "}
            → klik button Unduh
          </b>
          .
        </span>,
        <span>
          Tunggu, maks 1 menit (tergantung kecepatan jaringanmu) hasil
          Profilingmu akan terdownload di HP mu. Mudah bukan !
        </span>,
      ],
      briefDesc:
        "Profiling Personal Workstyle ini dibuat khusus untuk kamu, berbeda satu orang dengan yang lainnya.\n\nTemukan gaya kerjamu!\nDi Profiling Personal Workstyle ini, kamu bisa mengenal gaya kerjamu yang paling cocok dengan karaktermu dalam hitungan menit.",
    },
    2: {
      title: "Karakter Dalam Menjalin Hubungan",
      customHeader: "Cara Mendapatkan Profiling Karakter Menjalin Hubungan",
      desc: "",
      subDesc: "",
      isOrdered: true,
      points: [
        <span>
          Silakan untuk <b>Daftar/Login</b> terlebih dahulu.
        </span>,
        <span>
          Pastikan <b>data kelahiranmu</b> benar :{" "}
          <b>Tahun/Bulan/Hari/Jam, Jenis Kelamin</b>. Data ini mempengaruhi
          akurasi hasil profilingmu, untuk edit data bisa di cek di{" "}
          <b>
            <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                if (user && user !== "guess") {
                  window.location.assign("/dashboard/profile");
                } else {
                  localStorage.setItem("redirect_url", "/profiling");
                  window.location.assign("/login");
                }
              }}
            >
              Dashboard
            </span>{" "}
            → Edit Profile
          </b>
          .
        </span>,
        <span>
          Dilaman Profiling ini, klik <b>Beli Sekarang</b> muncul Draft Invoice
          → klik Lanjutkan pembayaran → muncul QRIS.
        </span>,
        <span>
          <b>Lakukan scan QRIS</b> untuk pembayaran dengan e-wallet atau mobile
          banking (Gopay, Link Aja, Dana, Shoopepay, Mobile Banking dll).
        </span>,
        <span>
          Setelah pembayaran berhasil, kamu akan diarahkan ke laman{" "}
          <b>
            <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                if (user && user !== "guess") {
                  window.location.assign("/dashboard/profile");
                } else {
                  localStorage.setItem("redirect_url", "/profiling");
                  window.location.assign("/login");
                }
              }}
            >
              Dashboard
            </span>{" "}
            → klik button Unduh
          </b>
          .
        </span>,
        <span>
          Tunggu, maks 1 menit (tergantung kecepatan jaringanmu) hasil
          Profilingmu akan terdownload di HP mu. Mudah bukan !
        </span>,
      ],
      briefDesc:
        "Profiling Karakter Menjalin Hubungan ini dibuat khusus untuk kamu, berbeda satu orang dengan yang lainnya.\n\nKamu tipe yang mana dalam hubungan ?\n Cari tahu di sini.\nDi Profiling Relationship Character ini, kamu bisa mengenal Karakter Hubunganmu dalam hitungan menit.",
    },
    3: {
      title: "Potensi Akademik",
      customHeader: "Cara Mendapatkan Profiling Potential Talent",
      desc: "",
      subDesc: "",
      isOrdered: true,
      points: [
        <span>
          Silakan untuk <b>Daftar/Login</b> terlebih dahulu.
        </span>,
        <span>
          Pastikan <b>data kelahiranmu</b> benar :{" "}
          <b>Tahun/Bulan/Hari/Jam, Jenis Kelamin</b>. Data ini mempengaruhi
          akurasi hasil profilingmu, untuk edit data bisa di cek di{" "}
          <b>
            <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                if (user && user !== "guess") {
                  window.location.assign("/dashboard/profile");
                } else {
                  localStorage.setItem("redirect_url", "/profiling");
                  window.location.assign("/login");
                }
              }}
            >
              Dashboard
            </span>{" "}
            → Edit Profile
          </b>
          .
        </span>,
        <span>
          Dilaman Profiling ini, klik <b>Beli Sekarang</b> muncul Draft Invoice
          → klik Lanjutkan pembayaran → muncul QRIS.
        </span>,
        <span>
          <b>Lakukan scan QRIS</b> untuk pembayaran dengan e-wallet atau mobile
          banking (Gopay, Link Aja, Dana, Shoopepay, Mobile Banking dll).
        </span>,
        <span>
          Setelah pembayaran berhasil, kamu akan diarahkan ke laman{" "}
          <b>
            <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                if (user && user !== "guess") {
                  window.location.assign("/dashboard/profile");
                } else {
                  localStorage.setItem("redirect_url", "/profiling");
                  window.location.assign("/login");
                }
              }}
            >
              Dashboard
            </span>{" "}
            → klik button Unduh
          </b>
          .
        </span>,
        <span>
          Tunggu, maks 1 menit (tergantung kecepatan jaringanmu) hasil
          Profilingmu akan terdownload di HP mu. Mudah bukan !
        </span>,
      ],
      briefDesc:
        "Profiling Potential Talent ini dibuat khusus untuk kamu, berbeda satu orang dengan yang lainnya.\n\nYuk ketahui jurusan kuliahmu?\nDi Profiling Talent ini, kamu bisa menemukan jurusan yang paling cocok dengan karaktermu.",
    },
    4: {
      title: "Bundling Career, Workstyle and Relationship",
      customHeader:
        "Cara Mendapatkan Complete Profiling : Karir, Workstyle dan Relationship",
      desc: "",
      subDesc: "",
      isOrdered: true,
      points: [
        <span>
          Silakan untuk <b>Daftar/Login</b> terlebih dahulu.
        </span>,
        <span>
          Pastikan <b>data kelahiranmu</b> benar :{" "}
          <b>Tahun/Bulan/Hari/Jam, Jenis Kelamin</b>. Data ini mempengaruhi
          akurasi hasil profilingmu, untuk edit data bisa di cek di{" "}
          <b>
            <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                if (user && user !== "guess") {
                  window.location.assign("/dashboard/profile");
                } else {
                  localStorage.setItem("redirect_url", "/profiling");
                  window.location.assign("/login");
                }
              }}
            >
              Dashboard
            </span>{" "}
            → Edit Profile
          </b>
          .
        </span>,
        <span>
          Dilaman Profiling ini, klik <b>Beli Sekarang</b> akan muncul Draft
          Invoice → klik Lanjutkan pembayaran → muncul QRIS.
        </span>,
        <span>
          <b>Lakukan scan QRIS</b> untuk pembayaran dengan e-wallet atau mobile
          banking (Gopay, Link Aja, Dana, Shoopepay, Mobile Banking dll).
        </span>,
        <span>
          Setelah pembayaran berhasil, kamu akan diarahkan ke laman{" "}
          <b>
            <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                if (user && user !== "guess") {
                  window.location.assign("/dashboard/profile");
                } else {
                  localStorage.setItem("redirect_url", "/profiling");
                  window.location.assign("/login");
                }
              }}
            >
              Dashboard
            </span>{" "}
            → klik button Unduh
          </b>
          .
        </span>,
        <span>
          Tunggu, maks 1 menit (tergantung kecepatan jaringanmu) hasil
          Profilingmu akan terdownload di HP mu. Mudah bukan !
        </span>,
      ],
      briefDesc:
        "Profiling Complete Profiling: Karir, Workstyle dan Relationship ini dibuat khusus untuk kamu, berbeda satu orang dengan yang lainnya.\n\nDi Complete Profiling ini, kamu dapat menemukan pilihan karir terbaikmu, gaya kerjamu, karakter hubunganmu dalam hitungan menit.",
    },
  };

  const action = (
    <div>
      <CircularProgress size={25} />
    </div>
  );

  return (
    <Flex direction="column" gap={5}>
      <Header active="profiling" />
      <Flex justifyContent="center" width="100%">
        <Flex
          maxWidth={1080}
          overflowX="hidden"
          width="100%"
          direction="column"
        >
          <Flex
            position="fixed"
            zIndex={1}
            pt={{ sm: 16, md: 10 }}
            bgColor="#fff"
            maxWidth={1080}
            gap={{ sm: 0, md: 5 }}
            flexWrap="nowrap"
            overflowX="auto"
            css={{
              "&::-webkit-scrollbar": {
                width: "0px",
                height: "4px",
              },
              "&::-webkit-scrollbar-track": {
                width: "4px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#CBD5E0",
                borderRadius: "24px",
              },
            }}
            width="100%"
          >
            <Flex direction="column" flex={1}>
              <Flex
                width={{ sm: 100, md: "100%" }}
                backgroundColor={activePage == 0 ? "#0045B0" : "#94A9D8"}
                cursor="pointer"
                borderTopRadius={10}
                mb={2}
                p={2}
                h={"30px"}
                justifyContent="center"
                alignItems="center"
                onClick={() => setActivePage(0)}
              >
                <Text
                  as="h1"
                  color="#fff"
                  fontSize={{ sm: "xs", md: "xs" }}
                  fontWeight="bold"
                  textAlign="center"
                >
                  CAREER
                </Text>
              </Flex>
            </Flex>
            <Flex direction="column" flex={1}>
              <Flex
                width={{ sm: 100, md: "100%" }}
                backgroundColor={activePage == 1 ? "#0045B0" : "#94A9D8"}
                cursor="pointer"
                borderTopRadius={10}
                mb={2}
                p={2}
                h={"30px"}
                justifyContent="center"
                alignItems="center"
                onClick={() => setActivePage(1)}
              >
                <Text
                  as="h1"
                  color="#fff"
                  fontSize={{ sm: "xs", md: "xs" }}
                  fontWeight="bold"
                  textAlign="center"
                >
                  WORKSTYLE
                </Text>
              </Flex>
            </Flex>
            <Flex direction="column" flex={1}>
              <Flex
                width={{ sm: 100, md: "100%" }}
                backgroundColor={activePage == 2 ? "#0045B0" : "#94A9D8"}
                cursor="pointer"
                borderTopRadius={10}
                mb={2}
                p={2}
                h={"30px"}
                justifyContent="center"
                alignItems="center"
                onClick={() => setActivePage(2)}
              >
                <Text
                  as="h1"
                  color="#fff"
                  fontSize={{ sm: "xs", md: "xs" }}
                  fontWeight="bold"
                  textAlign="center"
                >
                  RELATIONSHIP
                </Text>
              </Flex>
            </Flex>
            <Flex direction="column" flex={1}>
              <Flex
                width={{ sm: 100, md: "100%" }}
                backgroundColor={activePage == 3 ? "#0045B0" : "#94A9D8"}
                cursor="pointer"
                borderTopRadius={10}
                mb={2}
                p={2}
                h={"30px"}
                justifyContent="center"
                alignItems="center"
                onClick={() => setActivePage(3)}
              >
                <Text
                  as="h1"
                  color="#fff"
                  fontSize={{ sm: "xs", md: "xs" }}
                  fontWeight="bold"
                  textAlign="center"
                >
                  TALENT
                </Text>
              </Flex>
            </Flex>
            <Flex direction="column" flex={1}>
              <Flex
                width={{ sm: 100, md: "100%" }}
                backgroundColor={activePage == 4 ? "#0045B0" : "#94A9D8"}
                cursor="pointer"
                borderTopRadius={10}
                mb={2}
                p={2}
                h={"30px"}
                justifyContent="center"
                alignItems="center"
                onClick={() => setActivePage(4)}
              >
                <Text
                  as="h1"
                  color="#fff"
                  fontSize={{ sm: "xs", md: "xs" }}
                  fontWeight="bold"
                  textAlign="center"
                >
                  COMPLETE
                </Text>
              </Flex>
            </Flex>
          </Flex>

          <Flex
            mt={{ sm: "120px", md: "100px" }}
            flexDirection={{ sm: "column", md: "row" }}
            width="100%"
            gap={5}
            justifyContent="space-between"
            paddingX={{ sm: "20px", md: 0 }}
            display={{ base: "none", md: "flex" }}
          >
            <Flex
              flexDirection="column"
              width={{ sm: "100%", md: "40%" }}
              gap={3}
            >
              <Flex
                flexDirection="column"
                bgColor={color}
                px={3}
                py={2}
                borderTopRadius={10}
              >
                <Text color="white" fontWeight="bold">
                  {title}
                </Text>
                {title === "COMPLETE PROFILING" && (
                  <Text color="white" fontSize="xs">
                    Bundling: Career, Workstyle, Relationship
                  </Text>
                )}
              </Flex>
              {activePage === 0 ? (
                <>
                  <Flex
                    flexDirection="column"
                    gap={1}
                    backgroundRepeat="no-repeat"
                    borderWidth={1}
                    p={3}
                  >
                    <Flex flexDirection="column">
                      <Text fontWeight="bold">KERJA ITU SOAL PASSION !</Text>
                      <Text fontWeight="bold">BUKAN SEKADAR GAJI BULANAN</Text>
                    </Flex>
                    <Flex flexDirection="column">
                      <Text>
                        Bekerja bukan hanya untuk hidup, tapi juga untuk
                        berkembang. Upgrade dirimu, upgrade karirmu. Mulai dari
                        mengenal karir terbaikmu.
                      </Text>
                    </Flex>
                    <Flex flexDirection="column">
                      <Text>Temukan pilihan karirmu !</Text>
                      <Text>
                        Disini kamu bisa memilih pekerjaan yang paling cocok
                        dengan karaktermu dalam hitungan menit.
                      </Text>
                    </Flex>
                    <Text>#profillingseries#BestCareerOption</Text>
                  </Flex>
                  <Flex flexDirection="column" borderWidth={1} gap={5} p={3}>
                    <Text fontWeight="bold">
                      Temukan Karier yang Tepat Sesuai Bakatmu!
                    </Text>
                    <Text>
                      Jangan biarkan kariermu berjalan tanpa arah. Saatnya
                      kenali bakat, pilih jalan, dan wujudkan masa depan
                      terbaikmu!
                    </Text>
                    <Text>Mulai Profiling Kamu Sekarang !!</Text>
                    {isShowPricing ? (
                      <Flex
                        justify="end"
                        align="end"
                        display={{ md: "flex", sm: "none" }}
                      >
                        <Button
                          // width="100%"
                          bgColor="#2458EA"
                          color="white"
                          fontSize={{ sm: "xs", md: "sm" }}
                          fontWeight="500"
                          borderRadius="5px"
                          onClick={() => handleBuy()}
                          px="15px"
                          py="5px"
                        >
                          BELI PROFILING
                        </Button>
                      </Flex>
                    ) : (
                      <Flex
                        justify="end"
                        align="end"
                        display={{ md: "flex", sm: "none" }}
                      >
                        <Button
                          // width="100%"
                          bgColor="rgb(67, 148, 80)"
                          color="white"
                          fontSize={{ sm: "xs", md: "sm" }}
                          fontWeight="500"
                          borderRadius="5px"
                          onClick={() => onClickDownload()}
                          px="15px"
                          py="5px"
                        >
                          Download Profiling Kamu
                        </Button>
                      </Flex>
                    )}
                  </Flex>
                </>
              ) : activePage === 1 ? (
                <>
                  <Flex
                    flexDirection="column"
                    gap={1}
                    backgroundRepeat="no-repeat"
                    borderWidth={1}
                    p={3}
                  >
                    <Flex flexDirection="column">
                      <Text fontWeight="bold">PRODUKTIF TANPA DRAMA !</Text>
                      <Text fontWeight="bold">
                        CARI TAHU CARA KERJAMU YANG PALING PAS
                      </Text>
                    </Flex>
                    <Flex flexDirection="column">
                      <Text>
                        Bukan pekerjaan yang salah, tapi cara kerjamu.
                      </Text>
                      <Text>
                        Kerja lebih cerdas, bukan lebih keras. Kamu harus kenal
                        dulu gaya kerjamu.
                      </Text>
                    </Flex>
                    <Flex flexDirection="column">
                      <Text>Temukan personal workstyle kamu!</Text>
                      <Text>
                        Disini kamu bisa mengenal gaya kerjamu yang paling cocok
                        dengan karaktermu dalam hitungan menit.
                      </Text>
                    </Flex>
                    <Text>#profillingseries#PersonalWorkstyle</Text>
                  </Flex>
                  <Flex flexDirection="column" borderWidth={1} gap={5} p={3}>
                    <Text fontWeight="bold">
                      Temukan Workstyle-mu, Bekerja Lebih Kompak dan Produktif!
                    </Text>
                    <Text>
                      Semua ini bisa kamu capai lewat Analitik Persona Talenta –
                      cara praktis untuk memahami Workstyle dirimu maupun rekan
                      kerja.
                    </Text>
                    <Text>Mulai Profiling Kamu Sekarang !!</Text>
                    {isShowPricing ? (
                      <Flex
                        justify="end"
                        align="end"
                        display={{ md: "flex", sm: "none" }}
                      >
                        <Button
                          // width="100%"
                          bgColor="#2458EA"
                          color="white"
                          fontSize={{ sm: "xs", md: "sm" }}
                          fontWeight="500"
                          borderRadius="5px"
                          onClick={() => handleBuy()}
                          px="15px"
                          py="5px"
                        >
                          BELI PROFILING
                        </Button>
                      </Flex>
                    ) : (
                      <Flex
                        justify="end"
                        align="end"
                        display={{ md: "flex", sm: "none" }}
                      >
                        <Button
                          // width="100%"
                          bgColor="rgb(67, 148, 80)"
                          color="white"
                          fontSize={{ sm: "xs", md: "sm" }}
                          fontWeight="500"
                          borderRadius="5px"
                          onClick={() => onClickDownload()}
                          px="15px"
                          py="5px"
                        >
                          Download Profiling Kamu
                        </Button>
                      </Flex>
                    )}
                  </Flex>
                </>
              ) : activePage === 2 ? (
                <>
                  <Flex
                    flexDirection="column"
                    gap={1}
                    backgroundRepeat="no-repeat"
                    borderWidth={1}
                    p={3}
                  >
                    <Flex flexDirection="column">
                      <Text fontWeight="bold">
                        SEMUA HUBUNGANMU, DARI PASANGAN HINGGA TEMAN, DIMULAI
                        DARI DIRIMU SENDIRI !
                      </Text>
                    </Flex>
                    <Flex flexDirection="column">
                      <Text>
                        Hubunganmu adalah cerminan dirimu. Kenali diri, perbaiki
                        hubungan. Kenali karaktermu, maka kamu bisa membangun
                        hubungan yang terbaik.
                      </Text>
                    </Flex>
                    <Flex flexDirection="column">
                      <Text>
                        Kamu tipe yang mana dalam hubungan ? Cari tahu di sini.
                      </Text>
                      <Text>
                        Disini kamu bisa mengenal Karakter Hubunganmu dalam
                        hitungan menit.
                      </Text>
                    </Flex>
                    <Text>#profillingseries#RelationshipBehavior</Text>
                  </Flex>
                  <Flex flexDirection="column" borderWidth={1} gap={5} p={3}>
                    <Text fontWeight="bold">
                      Kenali Karakter, Bangun Hubungan yang Lebih Kuat!
                    </Text>
                    <Text>
                      Semua ini bisa kamu mulai dengan Persona Talenta – cara
                      praktis untuk memahami karakter diri sendiri, pasangan,
                      maupun partner bisnis.
                    </Text>
                    <Text>Mulai Profiling Kamu Sekarang !!</Text>
                    {isShowPricing ? (
                      <Flex
                        justify="end"
                        align="end"
                        display={{ md: "flex", sm: "none" }}
                      >
                        <Button
                          // width="100%"
                          bgColor="#2458EA"
                          color="white"
                          fontSize={{ sm: "xs", md: "sm" }}
                          fontWeight="500"
                          borderRadius="5px"
                          onClick={() => handleBuy()}
                          px="15px"
                          py="5px"
                        >
                          BELI PROFILING
                        </Button>
                      </Flex>
                    ) : (
                      <Flex
                        justify="end"
                        align="end"
                        display={{ md: "flex", sm: "none" }}
                      >
                        <Button
                          // width="100%"
                          bgColor="rgb(67, 148, 80)"
                          color="white"
                          fontSize={{ sm: "xs", md: "sm" }}
                          fontWeight="500"
                          borderRadius="5px"
                          onClick={() => onClickDownload()}
                          px="15px"
                          py="5px"
                        >
                          Download Profiling Kamu
                        </Button>
                      </Flex>
                    )}
                  </Flex>
                </>
              ) : activePage === 3 ? (
                <>
                  <Flex
                    flexDirection="column"
                    gap={1}
                    backgroundRepeat="no-repeat"
                    borderWidth={1}
                    p={3}
                  >
                    <Flex flexDirection="column">
                      <Text fontWeight="bold">
                        JURUSAN TEPAT MASA DEPAN CERAH !
                      </Text>
                    </Flex>
                    <Flex flexDirection="column">
                      <Text>
                        Bukan hanya sekadar pilih jurusan, namun pilih masa
                        depan yang sesuai dengan karaktermu. Yuk, cari yang
                        paling cocok dengan kepribadianmu!
                      </Text>
                    </Flex>
                    <Flex flexDirection="column">
                      <Text>Masih bingung pilih jurusanmu?</Text>
                      <Text>
                        Disini kamu bisa menemukan jurusan yang paling cocok
                        dengan karaktermu
                      </Text>
                    </Flex>
                    <Text>#profillingseries#Potential Talent</Text>
                  </Flex>
                  <Flex flexDirection="column" borderWidth={1} gap={5} p={3}>
                    <Text fontWeight="bold">
                      Studi Sesuai Talent, Sukses Jadi Lebih Mudah!
                    </Text>
                    <Text>
                      Semua ini bisa kamu mulai dengan Potential Talent –
                      panduan untuk menemukan jurusan dan potensi yang
                      benar-benar cocok dengan bakatmu.
                    </Text>
                    <Text>Mulai Profiling Kamu Sekarang !!</Text>
                    {isShowPricing ? (
                      <Flex
                        justify="end"
                        align="end"
                        display={{ md: "flex", sm: "none" }}
                      >
                        <Button
                          // width="100%"
                          bgColor="#2458EA"
                          color="white"
                          fontSize={{ sm: "xs", md: "sm" }}
                          fontWeight="500"
                          borderRadius="5px"
                          onClick={() => handleBuy()}
                          px="15px"
                          py="5px"
                        >
                          BELI PROFILING
                        </Button>
                      </Flex>
                    ) : (
                      <Flex
                        justify="end"
                        align="end"
                        display={{ md: "flex", sm: "none" }}
                      >
                        <Button
                          // width="100%"
                          bgColor="rgb(67, 148, 80)"
                          color="white"
                          fontSize={{ sm: "xs", md: "sm" }}
                          fontWeight="500"
                          borderRadius="5px"
                          onClick={() => onClickDownload()}
                          px="15px"
                          py="5px"
                        >
                          Download Profiling Kamu
                        </Button>
                      </Flex>
                    )}
                  </Flex>
                </>
              ) : activePage === 4 ? (
                <>
                  <Flex
                    flexDirection="column"
                    gap={1}
                    backgroundRepeat="no-repeat"
                    borderWidth={1}
                    p={3}
                  >
                    <Flex flexDirection="column">
                      <Text fontWeight="bold" fontSize="xl">
                        KERJA ITU SOAL PASSION!
                      </Text>
                      <Text fontWeight="bold">BUKAN SEKADAR GAJI BULANAN</Text>
                      <Text>
                        Bekerja bukan hanya untuk hidup, tapi juga untuk
                        berkembang.
                      </Text>
                      <Text>
                        Upgrade dirimu, upgrade karirmu. Mulai dari mengenal
                        karir terbaikmu
                      </Text>
                    </Flex>
                    <Flex flexDirection="column">
                      <Text fontWeight="bold" fontSize="xl">
                        PRODUKTIF TANPA DRAMA!
                      </Text>
                      <Text fontWeight="bold">
                        CARI TAHU CARA KERJAMU YANG PALING PAS
                      </Text>
                      <Text>
                        Bukan pekerjaan yang salah, tapi cara kerjamu.
                      </Text>
                      <Text>
                        Kerja lebih cerdas, bukan lebih keras. Kamu harus kenal
                        dulu gaya kerjamu.
                      </Text>
                    </Flex>
                    <Flex flexDirection="column">
                      <Text fontWeight="bold" fontSize="xl">
                        HUBUNGANMU DIMULAI DARI DIRIMU!
                      </Text>
                      <Text>
                        Hubunganmu adalah cerminan dirimu. Kenali diri, perbaiki
                        hubungan.
                      </Text>
                      <Text>
                        Kenali karaktermu, maka kamu bisa membangun hubungan
                        yang terbaik.
                      </Text>
                    </Flex>
                    <Flex flexDirection="column">
                      <Text>
                        Disini kamu dapat menemukan Complete Profiling mu dalam
                        hitungan menit.
                      </Text>
                    </Flex>
                    <Text>#profillingseries#CompleteProfiling</Text>
                  </Flex>
                  <Flex flexDirection="column" borderWidth={1} gap={5} p={3}>
                    <Text fontWeight="bold">
                      Kenali Profil Lengkapmu, Perjalanan Hidup Jadi Lebih
                      Terarah!
                    </Text>
                    <Text>
                      Profiling lengkap ini jadi fondasi penting untuk membuat
                      pilihan yang tepat—baik dalam pekerjaan maupun hubungan.
                    </Text>
                    <Text>Mulai Profiling Kamu Sekarang !!</Text>
                    {isShowPricing ? (
                      <Flex
                        justify="end"
                        align="end"
                        display={{ md: "flex", sm: "none" }}
                      >
                        <Button
                          // width="100%"
                          bgColor="#2458EA"
                          color="white"
                          fontSize={{ sm: "xs", md: "sm" }}
                          fontWeight="500"
                          borderRadius="5px"
                          onClick={() => handleBuy()}
                          px="15px"
                          py="5px"
                        >
                          BELI PROFILING
                        </Button>
                      </Flex>
                    ) : (
                      <Flex
                        justify="end"
                        align="end"
                        display={{ md: "flex", sm: "none" }}
                      >
                        <Button
                          // width="100%"
                          bgColor="rgb(67, 148, 80)"
                          color="white"
                          fontSize={{ sm: "xs", md: "sm" }}
                          fontWeight="500"
                          borderRadius="5px"
                          onClick={() => onClickDownload()}
                          px="15px"
                          py="5px"
                        >
                          Download Profiling Kamu
                        </Button>
                      </Flex>
                    )}
                  </Flex>
                </>
              ) : (
                <></>
              )}
              {/* <img src={img} alt="profile" className={styles.img} /> */}
              <Flex
                display={{ md: "flex", sm: "none" }}
                flexDirection="column"
                px={3}
                py={2}
                borderWidth={1}
              >
                {activePage === 0 ? (
                  <>
                    <Text>
                      Bayangkan bekerja di bidang yang benar-benar kamu kuasai
                      dan sukai.
                    </Text>
                    <Text>
                      Bukan hanya sekadar mencari nafkah, tapi juga membangun
                      masa depan yang lebih bahagia, produktif, dan penuh makna.
                    </Text>
                    <Text>
                      Dengan mengetahui profil bakatmu, kamu akan mendapatkan:
                    </Text>
                    <ol style={{ paddingLeft: "20px" }}>
                      <li>
                        <Text>
                          <b>Kerja Jadi Lebih Menyenangkan – </b>
                          Pekerjaan terasa ringan karena sesuai passion.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Potensi Diri Maksimal – </b>
                          Bakat alami berkembang jadi kekuatan utama.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Lebih Produktif dan Efisien – </b>
                          Hasil kerja lebih cepat dan berkualitas.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Karier Terarah – </b>
                          Jalur, tujuan, dan langkah masa depan lebih jelas.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Reputasi Positif – </b>
                          Keahlianmu diakui, peluang terbuka lebih luas.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Keputusan Karier Tepat – </b>
                          Lebih bijak memilih pekerjaan dan pengembangan diri.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Peluang Penghasilan Lebih Tinggi – </b>
                          Posisi strategis atau bisnis bisa jadi milikmu.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Visi Hidup Jelas – </b>
                          Merasa lebih terarah dengan tujuan besar di depan
                          mata.
                        </Text>
                      </li>
                    </ol>
                  </>
                ) : activePage === 1 ? (
                  <>
                    <Text>
                      Memahami gaya kerja diri sendiri dan rekan kerja bisa
                      bikin kolaborasi jadi lebih mudah, efisien, dan
                      menyenangkan.
                    </Text>
                    <Text>Dengan Profiling Workstyle, kamu akan dapat:</Text>
                    <ol style={{ paddingLeft: "20px" }}>
                      <li>
                        <Text>
                          <b>Lebih Produktif Dan Efisien – </b>
                          Tugas terbagi sesuai kekuatan masing-masing.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Minim Konflik, Maksimal Harmoni – </b>
                          Pahami perbedaan gaya kerja dan komunikasi.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Kerja Sama Lebih Optimal – </b>
                          Kolaborasi jadi lancar, tanpa miskomunikasi.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Keputusan Lebih Cepat dan Tepat – </b>
                          Kombinasi cepat bertindak + hati-hati = hasil terbaik.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Kerja Jadi Lebih Nyaman – </b>
                          Stres berkurang, kepuasan kerja meningkat.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Potensi Tumbuh, Kelemahan Tertutup – </b>
                          Saling melengkapi dengan rekan kerja.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Hubungan Kerja Lebih Solid – </b>
                          Rasa saling percaya makin kuat.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Siap Hadapi Perubahan – </b>
                          Tahu cara merespons tekanan dan situasi baru.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Karier Dan Bisnis Lebih Berkembang – </b>
                          Mudah menyesuaikan diri dengan berbagai tipe orang.
                        </Text>
                      </li>
                    </ol>
                  </>
                ) : activePage === 2 ? (
                  <>
                    <Text>
                      Baik dalam bisnis, pertemanan, maupun cinta, kunci
                      hubungan yang sehat dan tahan lama adalah saling memahami.
                      Dengan Profiling Persona Talenta, kamu bisa:
                    </Text>
                    <ol style={{ paddingLeft: "20px" }}>
                      <li>
                        <Text>
                          <b>Komunikasi Lebih Efektif – </b>
                          Sampaikan pesan dengan jelas, minim salah paham.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Kurangi Konflik – </b>
                          Pahami perbedaan cara berpikir dan atasi masalah lebih
                          bijak.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Tingkatkan Empati – </b>
                          Lebih mudah memahami posisi dan perasaan orang lain.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Seimbang Dan Saling Melengkapi – </b>
                          Introvert/ekstrovert, logis/emosional tetap harmonis.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Keputusan Lebih Matang – </b>
                          Gabungkan kelebihan masing-masing untuk hasil terbaik.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Ekspresikan Cinta dengan Tepat – </b>
                          Pahami love language pasanganmu.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Tumbuh Bersama – </b>
                          Dorong perkembangan pribadi dan hubungan, bukan saling
                          menyalahkan.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Rasa Aman Dan Percaya – </b>
                          Jadi diri sendiri tanpa takut dihakimi.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Siap Hadapi Tantangan – </b>
                          Lebih kuat menghadapi perubahan hidup dan pekerjaan.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Bahagia Lebih Lama – </b>
                          Hubungan jadi lebih hangat, menyenangkan, dan
                          langgeng.
                        </Text>
                      </li>
                    </ol>
                  </>
                ) : activePage === 3 ? (
                  <>
                    <Text>
                      Belajar di bidang yang sesuai dengan bakatmu bikin kuliah
                      terasa lebih ringan, menyenangkan, dan penuh peluang
                      sukses.
                    </Text>
                    <Text>Manfaat Pilihan Jurusan Studi Sesuai Talent:</Text>
                    <ol style={{ paddingLeft: "20px" }}>
                      <li>
                        <Text>
                          <b>Belajar Jadi Menyenangkan – </b>
                          Lebih semangat dan termotivasi.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Nilai Lebih Optimal – </b>
                          Cepat paham, hasil akademik meningkat.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Skill Berkembang Cepat – </b>
                          Talent alami jadi kekuatan utama.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Percaya Diri Meningkat – </b>
                          Lebih yakin hadapi tantangan.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Proses Kuliah Lebih Mudah – </b>
                          Materi, tugas, dan ujian terasa lebih ringan.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Karier Lebih Terarah – </b>
                          Passion + kemampuan = kepuasan dan keberhasilan lebih
                          besar.
                        </Text>
                      </li>
                    </ol>
                  </>
                ) : (
                  <>
                    <Text>
                      Dengan memahami karier yang cocok, gaya kerja yang pas,
                      dan relasi hubungan yang sehat, kamu bisa membuka pintu
                      menuju kesuksesan, kebahagiaan, dan kesejahteraan hidup.
                    </Text>
                    <Text>Manfaat Profiling Lengkap:</Text>
                    <ol style={{ paddingLeft: "20px" }}>
                      <li>
                        <Text>
                          <b>Karier Lebih Jelas Dan Optimal – </b>
                          Temukan bidang yang sesuai dengan bakat & minatmu.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Motivasi Dan Produktivitas Tinggi – </b>
                          Belajar dan bekerja jadi lebih semangat dan efisien.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Gaya Kerja Lebih Efektif – </b>
                          Ketahui cara kerja terbaikmu dan maksimalkan potensi.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Relasi Harmonis – </b>
                          Bangun hubungan kerja, sosial, dan cinta yang lebih
                          sehat.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Minim Konflik Dan Stres – </b>
                          Lebih mudah mengelola masalah dan menjaga keseimbangan
                          hidup.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Percaya Diri Dan Puas – </b>
                          Jalani hidup sesuai kekuatan dan kepribadianmu.
                        </Text>
                      </li>
                      <li>
                        <Text>
                          <b>Peluang Sukses Lebih Besar – </b>
                          Karier, bisnis, dan hubungan makin berkualitas.
                        </Text>
                      </li>
                    </ol>
                  </>
                )}
              </Flex>
            </Flex>
            <Flex flexDirection="column" width={{ sm: "100%", md: "60%" }}>
              <Flex
                flexDirection="column"
                bgColor={color}
                px={3}
                py={2}
                borderTopRadius={10}
              >
                <Text color="white" fontWeight="bold">
                  Contoh hasil profiling: {title}
                </Text>
              </Flex>

              {/* Solusi Mobile-First */}
              <Box
                width="100%"
                height="100%"
                overflow="auto"
                border="1px solid #ddd"
              >
                <Flex
                  display={{ sm: "flex", md: "none" }}
                  flexDirection="row"
                  alignItems="center"
                  justifyContent="center"
                  gap={2}
                >
                  <Flex flex={1}>
                    <img src={cover} alt="cover" className={styles.cover} />
                  </Flex>
                  <Flex flex={3} flexDirection="column">
                    <Text>
                      Kamu bisa melihat contoh hasil Profiling {title}, dengan
                      Klik button Contoh Hasil Profiling dibawah ini !
                    </Text>
                    <Button
                      // width="100%"
                      bgColor="#B02418"
                      color="white"
                      fontSize={{ sm: "xs", md: "sm" }}
                      fontWeight="500"
                      borderRadius="5px"
                      onClick={() => downloadPdf(url, title)}
                      px="15px"
                      py="5px"
                    >
                      Lihat Contoh Hasil Profiling
                    </Button>
                  </Flex>
                </Flex>
                <Flex height="100%" display={{ sm: "none", md: "block" }}>
                  <object
                    data={`${url}#zoom=page-width&pagemode=none&toolbar=1`}
                    type="application/pdf"
                    width="100%"
                    height="100%"
                    style={{
                      minHeight: "100%",
                      display: "block",
                    }}
                  >
                    <embed
                      src={`${url}#zoom=page-width&pagemode=none&toolbar=1`}
                      type="application/pdf"
                      width="100%"
                      height="100%"
                      style={{ minHeight: "100%" }}
                    />
                  </object>
                </Flex>
              </Box>
            </Flex>
            <Flex
              display={{ md: "none", sm: "flex" }}
              flexDirection="column"
              px={3}
              py={2}
              borderWidth={1}
            >
              {activePage === 0 ? (
                <>
                  <Text>
                    Mengetahui karir yang sesuai dengan bakat memiliki banyak
                    manfaat, baik dari segi profesional maupun personal. Berikut
                    yang akan Kamu dapatkan dengan mengetahui Profilingmu:
                  </Text>
                  <ol style={{ paddingLeft: "20px" }}>
                    <li>
                      <Text>
                        <b>Meningkatkan Kepuasan dan Kebahagiaan Kerja</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Mengoptimalkan Potensi Diri</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Produktivitas yang Lebih Tinggi</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Memudahkan Pengembangan Karier</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Lebih Mudah Membangun Reputasi Positif</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>
                          Membantu Pengambilan Keputusan Karir yang Lebih Tepat
                        </b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Peluang Penghasilan yang Lebih Besar</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Memiliki Tujuan Hidup yang Lebih Jelas</b>
                      </Text>
                    </li>
                  </ol>
                  <b>
                    Apakah kamu ingin PERSONA membantu mengidentifikasi karir
                    yang paling cocok dengan bakatmu?
                  </b>
                </>
              ) : activePage === 1 ? (
                <>
                  <Text>
                    Memahami Workstyle (gaya kerja) diri sendiri dan rekan kerja
                    memberikan banyak manfaat dalam sebuah kerja sama. Berikut
                    yang akan Kamu dapatkan dengan mengetahui Profilingmu:{" "}
                  </Text>
                  <ol style={{ paddingLeft: "20px" }}>
                    <li>
                      <Text>
                        <b>Meningkatkan Efisiensi dan Produktivitas.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Mengurangi Konflik dan Meningkatkan Harmoni.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Pembagian Tugas yang Lebih Optimal.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Kolaborasi yang Lebih Efektif.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Pengambilan Keputusanyang Lebih Cepat dan Tepat.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Peningkatan Kepuasan Kerja.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Mengoptimalkan Potensi dan Mengurangi Kelemahan.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>
                          Membangun Kepercayaan dan Menguatkan Hubungan Kerja.
                        </b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Lebih Mudah Menghadapi Perubahan dan Tekanan.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Mendukung Pengembangan Karier dan Bisnis.</b>
                      </Text>
                    </li>
                  </ol>
                  <Text>
                    Memahami workstyle ini bisa dicapai dengan berbagai cara,
                    seperti melalui diskusi terbuka, tes kepribadian, feedback
                    yang jujur, dan observasi langsung.
                  </Text>
                  <b>
                    Kamu pernah mencoba memahami workstyle rekan kerja atau
                    partner bisnismu? Atau mungkin tertarik untuk tahu workstyle
                    kamu sendiri dulu? Cobalah dengan hasil Analitik Persona
                    Talenta ini.
                  </b>
                </>
              ) : activePage === 2 ? (
                <>
                  <Text>
                    Memahami karakter pasangan dalam menjalin relasi sosial dan
                    cinta memberikan banyak manfaat yang sangat penting untuk
                    menjaga hubungan yang sehat, bahagia, dan bertahan lama.
                    Berikut yang akan Kamu dapatkan dengan mengetahui
                    Profilingmu:
                  </Text>
                  <ol style={{ paddingLeft: "20px" }}>
                    <li>
                      <Text>
                        <b>Meningkatkan Komunikasi yang Efektif.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Mengurangi Konflik dan Pertengkaran.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Membangun Empati dan Pengertian.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Menciptakan Keseimbangan dalam Hubungan.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Pengambilan Keputusan yang Lebih Bijak.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Menemukan Pola Cinta (Love Language) yang Tepat.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Membantu Pertumbuhan Pribadi dan Hubungan.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Meningkatkan Kepercayaan dan Rasa Aman.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Lebih Mudah Menghadapi Perubahan dan Tantangan.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Menikmati Hubungan dengan Lebih Bahagia.</b>
                      </Text>
                    </li>
                  </ol>
                  <Text>
                    Memahami karakter pasangan biasanya bisa dilakukan melalui
                    komunikasi yang terbuka, observasi, pengalaman bersama, atau
                    bahkan melalui tes psikologi atau diskusi mendalam.
                  </Text>
                  <Text>
                    Menurutmu, apakah kamu sudah benar-benar memahami karakter
                    pasanganmu? Atau mungkin kamu ingin mencoba metode tertentu
                    untuk lebih memahami dia?
                  </Text>
                  <b>Metoda PERSONA TALENTA ini layak Kamu Coba ......</b>
                </>
              ) : activePage === 3 ? (
                <>
                  <Text>Manfaat Kuliah Sesuai Dengan Talent:</Text>
                  <ol style={{ paddingLeft: "20px" }}>
                    <li>
                      <Text>
                        <b>Meningkatkan Motivasi dan Semangat Belajar.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Hasil Belajar yang Lebih Optimal.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Pengembangan Diri yang Lebih Cepat.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Membangun Kepercayaan Diri.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Kemudahan Menjalani Proses Perkuliahan.</b>
                      </Text>
                    </li>
                  </ol>
                  <Text>
                    Kuliah dan bekerja sesuai dengan talent memungkinkan kamu
                    menggabungkan passion, kemampuan alami, dan keterampilan
                    yang diasah.
                  </Text>
                  <Text>
                    Hal ini menghasilkan produktifitas, kepuasan, dan
                    keberhasilan yang lebih besar dibandingkan jika kamu bekerja
                    di bidang yang tidak kamu kuasai atau tidak kamu sukai.
                  </Text>
                  <Text>
                    Menurutmu, apakah jalur pendidikan dan karier yang kamu
                    pilih saat ini sudah sesuai dengan talentamu? Atau kamu
                    masih mencari tahu apa talentamu yang sebenarnya?
                  </Text>
                </>
              ) : (
                <>
                  <Text>
                    Mengetahui profil komplit dengan memahmi karir yang cocok,
                    gaya kerja yang pas, dan memahami relasi hubungan secara
                    komplit memberikan manfaat yang besar dan menyeluruh dalam
                    hidup. Ini bisa berdampak positif dalam aspek karier,
                    produktivitas, hubungan sosial, cinta, dan bahkan
                    kesejahteraan mental. Berikut yang akan Kamu dapatkan dengan
                    mengetahui Profilingmu:
                  </Text>
                  <ol style={{ paddingLeft: "20px" }}>
                    <li>
                      <Text>
                        <b>
                          Pengembangan Karier yang Lebih Tepat, Optimal dan
                          Jelas
                        </b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Motivasi Lebih Tinggi.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>
                          Produktivitas dan Efisiensi yang Lebih Tinggi (Gaya
                          Kerja yang Pas)
                        </b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Metode Kerja yang Lebih Efektif</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>
                          Membangun Relasi yang Lebih Harmonis (Relasi Hubungan
                          yang Komplit)
                        </b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Hubungan Cinta yang Lebih Bahagia</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Mengurangi Konflik dan Stres</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Meningkatkan Kepercayaan Diri dan Kepuasan Hidup.</b>
                      </Text>
                    </li>
                    <li>
                      <Text>
                        <b>Membuka Peluang Lebih Besar untuk Sukses.</b>
                      </Text>
                    </li>
                  </ol>
                  <Text>
                    Mengetahui profil karier yang cocok, gaya kerja yang pas,
                    dan memahami relasi hubungan secara komplit adalah fondasi
                    penting untuk meraih sukses, kebahagiaan, dan kesejahteraan
                    hidup. Ini membantu kamu membuat pilihan yang lebih tepat,
                    baik dalam pekerjaan maupun hubungan, sehingga menciptakan
                    kehidupan yang lebih seimbang dan memuaskan.
                  </Text>
                  <Text>
                    Menurutmu, apakah kamu sudah memahami ketiga aspek ini dalam
                    dirimu? Atau apakah kamu ingin mulai mencari tahu dari salah
                    satu aspek dulu, misalnya profil karier atau gaya kerja?
                  </Text>
                </>
              )}
              <Flex justify="end" align="end">
                <Button
                  // width="100%"
                  bgColor="#2458EA"
                  color="white"
                  fontSize={{ sm: "xs", md: "sm" }}
                  fontWeight="500"
                  borderRadius="5px"
                  onClick={() => handleBuy()}
                  px="15px"
                  py="5px"
                >
                  BELI PROFILING
                </Button>
              </Flex>
            </Flex>
          </Flex>

          {/* New Mobile Content View */}
          <Flex
            mt={{ base: "130px", md: "100px" }}
            flexDirection="column"
            width="100%"
            gap={5}
            px="20px"
            display={{ base: "flex", md: "none" }}
            mb={10}
          >
            {/* Card 2: Contoh Hasil Profiling */}
            <Box
              border="1px solid #E2E8F0"
              borderRadius="md"
              p={4}
              bg="white"
              boxShadow="sm"
            >
              <Text fontWeight="bold" fontSize="lg" mb={3}>
                Contoh hasil Profiling
              </Text>
              <Flex gap={4} alignItems="center">
                <Box width="80px" flexShrink={0}>
                  <img
                    src={cover}
                    alt="Cover Profiling"
                    style={{
                      width: "100%",
                      borderRadius: "4px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  />
                </Box>
                <Flex direction="column" flex={1}>
                  <Text fontSize="sm" mb={3}>
                    Lihat contoh laporan profiling untuk memahami format dan isi
                    yang akan Anda dapatkan.
                  </Text>
                  <Button
                    size="sm"
                    fontSize="xs"
                    colorScheme="blue"
                    px={3}
                    py={1}
                    variant="outline"
                    borderColor="#0045B0"
                    borderWidth={1}
                    borderRadius={"md"}
                    color="black"
                    fontWeight="normal"
                    bg="#E2E8F0"
                    _hover={{ bg: "#CBD5E0" }}
                    width="fit-content"
                    onClick={() => downloadPdf(url, title)}
                  >
                    Unduh Contoh
                  </Button>
                </Flex>
              </Flex>
            </Box>

            {/* Card 1: Profiling Info */}
            <Box
              border="1px solid #E2E8F0"
              borderRadius="md"
              p={4}
              bg="white"
              boxShadow="sm"
            >
              <Flex
                justifyContent="space-between"
                alignItems="center"
                mb={3}
                gap={2}
              >
                <Text fontWeight="bold" fontSize="lg">
                  {mobileContentData[activePage].customHeader ||
                    `Profiling : ${mobileContentData[activePage].title}`}
                </Text>
                {!user && (
                  <Button
                    size="sm"
                    bgColor="#0045B0"
                    color="white"
                    fontSize="xs"
                    px={3}
                    py={1}
                    borderRadius="5px"
                    onClick={() => {
                      localStorage.setItem("redirect_url", "/profiling");
                      window.location.assign("/login");
                    }}
                    _hover={{ bg: "#00348a" }}
                    flexShrink={0}
                  >
                    Daftar Gratis
                  </Button>
                )}
              </Flex>
              <Text fontSize="sm" mb={2} lineHeight="1.6" textAlign="justify">
                {mobileContentData[activePage].desc}
              </Text>
              {mobileContentData[activePage].subDesc && (
                <Text fontSize="sm" mb={2}>
                  {mobileContentData[activePage].subDesc}
                </Text>
              )}
              <Box pl={4}>
                {mobileContentData[activePage].isOrdered ? (
                  <ol style={{ margin: 0 }}>
                    {mobileContentData[activePage].points?.map((point, idx) => (
                      <li
                        key={idx}
                        style={{ fontSize: "14px", marginBottom: "4px" }}
                      >
                        {point}
                      </li>
                    ))}
                  </ol>
                ) : (
                  <ul style={{ margin: 0 }}>
                    {mobileContentData[activePage].points?.map((point, idx) => (
                      <li
                        key={idx}
                        style={{ fontSize: "14px", marginBottom: "4px" }}
                      >
                        {point}
                      </li>
                    ))}
                  </ul>
                )}
              </Box>
            </Box>

            {/* Card 3: Brief Profiling / CTA */}
            <Box
              border="1px solid #E2E8F0"
              borderRadius="md"
              p={4}
              bg="white"
              boxShadow="sm"
            >
              <Text fontWeight="bold" fontSize="lg" mb={3}>
                Profiling Kamu
              </Text>
              <Text fontSize="sm" mb={4} whiteSpace="pre-line" lineHeight="1.6">
                {mobileContentData[activePage].briefDesc}
              </Text>

              <Flex justifyContent="space-between" alignItems="center" mt={4}>
                <Box>
                  <Text fontSize="sm">Hanya dengan Investasi</Text>
                  <Text fontSize="md" fontWeight="bold">
                    Rp.{" "}
                    {products.find((p) => p.code === code)?.price
                      ? formatPrice(
                          products.find((p) => p.code === code)?.price,
                        )
                      : "-"}
                  </Text>
                </Box>
                {isShowPricing ? (
                  user ? (
                    <Button
                      colorScheme="blue"
                      bg="#0045B0"
                      color="white"
                      borderRadius={"md"}
                      size="sm"
                      px={6}
                      onClick={() => handleBuy()}
                    >
                      Beli Profiling
                    </Button>
                  ) : null
                ) : (
                  <Button
                    colorScheme="green"
                    bg="green.500"
                    color="white"
                    borderRadius={"md"}
                    size="sm"
                    px={6}
                    onClick={() => onClickDownload()}
                  >
                    Download
                  </Button>
                )}
              </Flex>
            </Box>
          </Flex>
        </Flex>
      </Flex>
      <Footer />
      <BootstrapDialog
        onClose={handleClosePricing}
        maxWidth="lg"
        open={isShowModalPricing}
      >
        <DialogTitle
          sx={{ m: 0, p: 3 }}
          id="customized-dialog-title"
        ></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClosePricing}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon width={3} />
        </IconButton>
        <DialogContent dividers>
          <Flex
            flexDirection="column"
            wrap="wrap"
            maxWidth="100%"
            gap={1}
            alignItems="center"
            justifyContent="center"
          >
            <PricingProfiling user={user} product={service} />
          </Flex>
        </DialogContent>
      </BootstrapDialog>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={loadingDownload}
        onClose={handleClose}
        style={{ top: 50 }}
      >
        <SnackbarContent
          style={{ height: 80, backgroundColor: "#CADFB8", color: "#000" }}
          action={action}
          message={
            <div>
              <span id="client-snackbar">
                Saat ini dokumen sedang proses download, kecepatan bergantung
                pada jaringan anda
              </span>
            </div>
          }
        />
      </Snackbar>
    </Flex>
  );
};

export default Profiling;
